import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconJuniorSuite = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconJuniorSuite",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M9.32 3a1 1 0 0 1 1-1h6.07a1 1 0 0 1 1 1v3.77a1 1 0 0 1-1 1h-6.07a1 1 0 0 1-1-1zm2.77 1.4.86 1.03L14.2 3.8a.2.2 0 0 1 .33 0l1.42 1.9a.2.2 0 0 1-.16.33h-4.86a.2.2 0 0 1-.16-.33l1-1.3a.2.2 0 0 1 .32 0M5.06 7.1h2.15l-.36-3.95h-4.3L2.2 7.1h2.15v7.03a1.3 1.3 0 0 1 .71-1.16zm15.21 6.14v-2.6c0-.94-.78-1.72-1.73-1.72H8.16c-.95 0-1.73.78-1.73 1.73v2.6c-.95 0-1.73.77-1.73 1.72v4.33h1.15l.44 1.32a.6.6 0 0 0 1.15 0l.44-1.32h10.95l.45 1.32c.07.24.3.4.56.4a.6.6 0 0 0 .57-.4l.44-1.32H22v-4.33c0-.95-.78-1.73-1.73-1.73m-7.78 0H8.16v-1.73c0-.47.4-.86.87-.86h3.46zm6.05 0h-4.32v-2.6h3.46c.47 0 .86.4.86.87z"
  })
}));